import { Reveal, SectionLabel } from "./Reveal";
import jonnyHeadshot from "../../assets/founders/jonny_headshot.png";
import colbyHeadshot from "../../assets/founders/colby_headshot.png";

const FOUNDERS = [
  {
    name: "Jonny Lintell",
    title: "Co-Founder & Head of Performance",
    img: jonnyHeadshot,
    bio: "A college pitcher who has run his fastball into the mid-90s, Jonny trains the way he throws — built on mechanics, sequencing, and data. He studies pharmacology and applied physiology, bringing a first-principles, science-backed approach to velocity development and recovery. Jonny founded Fuel Factory on a simple belief: real improvement comes from understanding the mechanics and trusting the data, not guesswork. He leads the facility's performance systems, biomechanics methodology, and athlete development framework.",
  },
  {
    name: "Colby Lintell",
    title: "Co-Founder & Head of Sales & Marketing",
    img: colbyHeadshot,
    bio: "A Fairfield Prep alum and college baseball player with 12 years of pitching experience, Colby pairs on-the-mound credibility with the business engine behind Fuel Factory. He leads sales, marketing, and brand growth — connecting serious athletes and families with a training system built to deliver measurable results. Having trained the way Fuel Factory trains, he speaks the athlete's language.",
  },
];

export const Founders = () => (
  <section
    id="founders"
    data-testid="founders-section"
    className="relative border-t border-white/10 bg-[#050505] py-24 md:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mb-16 max-w-4xl">
        <Reveal>
          <SectionLabel>[ Meet the Founders ]</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-heading text-3xl font-black uppercase leading-[0.95] tracking-tight text-white md:text-5xl lg:text-6xl">
            Founded by two brothers who built the pitching development system they{" "}
            <span className="text-[#00F0FF]">wish they'd had.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-8">
        {FOUNDERS.map((f, i) => (
          <Reveal
            key={f.name}
            delay={i * 0.15}
            className="group border border-white/10 bg-white/[0.015] p-6 transition-colors duration-300 hover:border-white/25 md:p-8"
            data-testid={`founder-card-${i}`}
          >
            <div className="relative mb-6 overflow-hidden">
              <img
                src={f.img}
                alt={f.name}
                className="h-[360px] w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <span className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#00F0FF]">
                {String(i + 1).padStart(2, "0")} / Co-Founder
              </span>
            </div>
            <h3 className="font-heading text-3xl font-black uppercase tracking-tight text-white">
              {f.name}
            </h3>
            <p className="mt-1 font-mono text-xs uppercase tracking-[0.15em] text-[#00F0FF]">
              {f.title}
            </p>
            <p className="mt-5 font-body text-sm leading-relaxed text-white/60">{f.bio}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Founders;
